export function displayReferenceSeconds(value: number): number {
  return Math.ceil(value * 100 - 1e-8) / 100;
}

// Only known constraints and finite numeric values become user-facing messages.
export function referenceViolationDescriptor(details: unknown): { id: string; values: Record<string, number> } | null {
  if (!details || typeof details !== 'object') return null;
  const d = details as Record<string, unknown>;
  if (d.media !== 'video' && d.media !== 'audio') return null;
  const index = typeof d.index === 'number' && Number.isInteger(d.index) && d.index > 0 ? d.index : 0;
  const t = (suffix: string, values: Record<string, number> = {}) =>
    ({ id: `referenceError.${d.media}.${suffix}`, values });
  if (d.kind === 'duration_total' || d.kind === 'duration_segment') {
    if (typeof d.actual !== 'number' || !Number.isFinite(d.actual) ||
        typeof d.limit !== 'number' || !Number.isFinite(d.limit) || d.limit <= 0 || d.actual <= d.limit) return null;
    if (d.kind === 'duration_segment' && !index) return null;
    return t(d.kind, {
      index,
      actual: displayReferenceSeconds(d.actual),
      max: d.limit,
      excess: displayReferenceSeconds(d.actual - d.limit),
    });
  }
  const reasons = ['timeout', 'unavailable', 'wrong_type', 'too_large', 'invalid_url', 'download_failed', 'unreadable'];
  if (d.kind === 'read_failed' && index && typeof d.reason === 'string' && reasons.includes(d.reason)) {
    return t(d.reason, { index });
  }
  return null;
}
